import { vars } from '@repo/config';
import type { IAuthenticateTelegramRequest } from '../authenticateTelegramApi/authenticate-telegram-request';
import type { IAuthenticateTelegramV2Response } from './authenticate-telegram-v2-response';

export async function authenticateTelegramV2Api(
  body: IAuthenticateTelegramRequest,
): Promise<IAuthenticateTelegramV2Response> {
  const url = new URL('/telegram/verify/v2', vars.url.identityUrl);

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  } as RequestInit);

  if (!response.ok) {
    const text = await response.text().catch(() => '');
    const err = new Error(`Telegram auth v2 failed: ${response.status} ${text.slice(0, 200)}`);
    (err as Error & { status?: number; body?: string }).status = response.status;
    (err as Error & { status?: number; body?: string }).body = text;
    throw err;
  }

  return response.json() as Promise<IAuthenticateTelegramV2Response>;
}
